

import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";

import './App.css';
import About from "./component/about";
import Contact from "./component/contact";
import Footer from "./component/footer";
import Galery from "./component/galery";
import Header from "./component/header";
import IconTel from "./component/iconTel";
import IconWhat from "./component/iconWhat";
import InArea from "./component/inArea";



function App() {
  return (
    <Router>
      {/* <IconTel /> */}
      {/* <IconWhat/> */}
      <div id="app">
        <Header />
        <About />
        <Galery />
        <InArea />
        <Contact />
        <Footer />


      </div>


    </Router>

  );
}

export default App;
